import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';

class Termes extends React.Component {

  constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="animated fadeIn">
        <div className="row row-margin-bottom-100">
        <div className="col-md-12 col-xs-12">

					<h4>TERMES ET CONDITIONS</h4>

					<div><p>
						Les présentes conditions générales régissent l’utilisation des ce site <i>Statelo</i>.<br/>
						Ce site appartient et est géré par DevAxia.<br/>
						En utilisant ce site, vous indiquez que vous avez lu et compris les conditions d’utilisation et que vous 
						acceptez de les respecter en tout temps.<br/>
						Type de site: affichage de données liées aux ligues et tournois de billard
					</p></div>

					<div>
						<h5>Propriété intellectuelle</h5>
						<p>Tout contenu publié et mis à disposition sur ce site est la propriété de DevAxia et de ses créateurs. 
						Cela comprend, mais n’est pas limité aux images, textes, logos, documents, fichiers téléchargeables et tout ce qui 
						contribue à la composition de ce site.
						</p>
					</div>

					<div>
					<h5>Comptes</h5>
					<p>Lorsque vous créez un compte sur notre site, vous acceptez ce qui suit :</p>
					<ul>
						<li>
							que vous êtes seul responsable de votre compte et de la sécurité et la confidentialité de votre 
							compte, y compris les mots de passe ou les renseignements de nature délicate joints à ce compte, et
						</li>
						<li>
							que tous les renseignements personnels que vous nous fournissez par l’entremise de votre compte sont à jour,
							exacts et véridiques et que vous mettrez à jour vos renseignements personnels s’ils changent.
						</li>
					</ul>
					</div>

					<div>
						<p> Nous nous réservons le droit de suspendre ou de résilier votre compte si vous utilisez notre site illégalement 
						ou si vous violez les conditions d’utilisation acceptable. </p>
					</div>

					<div>
					<h5>Ventes des biens et services</h5>
					<p>Ce document régit la vente de services mis à disposition sur notre site.</p>
					<p>Les services que nous offrons comprennent: Abonnements au tableau de bord</p>
					</div>

					<div><p>
						Les services liés à ce document sont les services qui sont affichés sur notre site au moment où vous y accédez. 
						Cela comprend tous les produits énumérés comme étant en rupture de stock. Toutes les informations, descriptions 
						ou images que nous fournissons sur nos services sont décrites et présentées avec la plus grande précision possible. 
						Cependant, nous ne sommes pas légalement &nbsp;tenus par ces informations, descriptions ou images car nous ne 
						pouvons pas garantir l’exactitude de chaque produit ou service que nous fournissons. Vous acceptez d’acheter 
						ces services à vos propres risques.
					</p></div>
	
					<div>
						<h5>Paiements</h5>
						<p>Nous acceptons les modes de paiement suivants sur ce site: PayPal</p>
					</div>
		
					<div><p>
						Lorsque vous nous fournissez vos renseignements de paiement, vous nous confirmez que vous avez autorisé 
						l’utilisation et l’accès à l’instrument de paiement que vous avez choisi d’utiliser. En nous fournissant 
						vos détails de paiement, vous confirmez que vous nous autorisez à facturer le montant dû à cet instrument 
						de paiement.<br/><br/>Si nous estimons que votre paiement a violé une loi ou l’une de nos conditions 
						d’utilisation, nous nous réservons le droit d’annuler votre transaction.
					</p></div>
	
					<div><p>
						<i>Abonnements</i><br/>Votre abonnement ne se renouvelle pas automatiquement. Vous serez informé 
						avant votre prochain paiement afin de poursuivre votre abonnement.
					</p></div>

					<div>
						<h5>Limitation de responsabilité</h5>
						<p> DevAxia ou l’un de ses employés sera tenu responsable 
							de tout problème découlant de ce site. Néanmoins, DevAxia et ses employés ne seront pas tenus responsables 
							de tout problème découlant de toute utilisation irrégulière de ce site.
						</p>
					</div>

					<div>
						<h5>Indemnité</h5>
						<p>En tant qu’utilisateur, vous indemnisez par les présentes DevAxia de 
							toute responsabilité, de tout coût, de toute cause d’action, de tout dommage ou de toute dépense découlant de 
							votre utilisation de ce site ou de votre violation de l’une des dispositions énoncées dans le présent document.
						</p>
					</div>

					<div>
						<h5>Lois applicables</h5>
						<p> Ce document est soumis aux lois applicables du Canada et vise à se conformer à ses règles et règlements 
							nécessaires.<br/> Pour les résidents de l’UE, le RGPD est la loi applicable qui régit ce document. 
							En cas d’incompatibilité entre une disposition du présent document et le RGPD, les règles du RGPD auront préséance.
						</p>
					</div>

					<div>
						<h5>Divisibilité</h5>
						<p>Si, à tout moment, l’une des dispositions énoncées dans le présent document 
							est jugée incompatible ou invalide en vertu des lois applicables, ces dispositions seront considérées comme 
							nulles et seront retirées du présent document. Toutes les autres dispositions ne seront pas touchées par les 
							lois et le reste du document sera toujours considéré comme valide.
						</p>
					</div>

					<div>
					<h5>Modifications</h5>
					<p>Ces conditions générales peuvent être modifiées de temps à autre afin 
						de maintenir le respect de la loi et de refléter tout changement à la façon dont nous gérons notre site et la 
						façon dont nous nous attendons à ce que les utilisateurs se comportent sur notre site. Nous recommandons à nos 
						utilisateurs de vérifier ces conditions générales de temps à autre pour s’assurer qu’ils sont informés de toute 
						mise à jour. Au besoin, nous informerons les utilisateurs par courriel des changements apportés à ces conditions 
						ou nous afficherons un avis sur notre site.
					</p>
					</div>

					<div>
					<h5>Contact</h5>
					<p>
						Veuillez communiquer avec nous si vous avez des questions ou des préoccupations.<br/> 
						Nos coordonnées sont les suivantes: DevAxia, statelo@devaxia.com
					</p>
					</div>
						
					<div>
						<p>Date d'entrée en vigueur: le 1 janvier 2021.</p>
					</div>

        </div>
        </div>
      </div>
		);
	}

}

export default Termes;